import React, { useEffect, useState } from "react"
import { List, ListItem, ListItemText, ListItemAvatar, Chip, Box } from "@material-ui/core"
import { useParams, NavLink, useHistory } from "react-router-dom"
import moment from "moment"
import { Star } from "@material-ui/icons"
import { Content, AreaHeader, LoadingSpinner, Avatar, Icon, TimeAgo, SearchInput, IconMessage } from "../../components"
import { useLazyQuerySearchAll } from "../../data"
import { usePostUtils, useJobUtils, useKnowledgeUtils, toId } from "../../utils"

import { useAuth } from "../../services"

const getResultTypeName = (type) => {
  switch (type) {
    case "Post":
      return "Communications Hub"
    case "Process":
    case "Task":
      return "Jobs"
    case "Knowledge":
      return "Knowledge Base"
    default:
      return ""
  }
}

const Search = () => {
  const { query } = useParams()
  const history = useHistory()
  const [searchText, setSearchText] = useState(null)
  const { location } = useAuth()
  const [load, { called, loading, data }] = useLazyQuerySearchAll()

  const { getNavigateToLink: getPostLink } = usePostUtils()
  const { getNavigateToLinkForTypeLocationDayAndID: getJobLink } = useJobUtils()
  const { getNavigateToArticleLinkForID: getKnowledgeLink } = useKnowledgeUtils()

  const handleSearchChange = (value) => {
    history.push(`/search/${encodeURIComponent(value)}`)
  }

  useEffect(() => {
    if (query) setSearchText(query.trim())
  }, [query])

  useEffect(() => {
    if (searchText) {
      load({ variables: { searchText, location: toId(location) } })
    }
  }, [load, location, searchText])

  return (
    <>
      <AreaHeader title="Search" titleIcon="search" />

      <Content full start>
        <SearchInput
          initialValue={query}
          debounce={500}
          placeholder="Enter a search term"
          onChange={handleSearchChange}
          autoFocus
        />

        {loading && (
          <Box display="flex" justifyContent="center">
            <LoadingSpinner size={60} />
          </Box>
        )}
        {data && (
          <List>
            {data.searchAll.results.items.map(({ id, title, type, date, score }) => (
              <ListItem
                key={id}
                component={NavLink}
                to={() => {
                  switch (type) {
                    case "Post":
                      return getPostLink({ id })
                    case "Process":
                    case "Task":
                      return getJobLink(type, moment(date).format("YYYY-MM-DD"), id)
                    case "Knowledge":
                      return getKnowledgeLink(id)
                    default:
                      return ""
                  }
                }}
              >
                <ListItemAvatar>
                  <Avatar icon={<Icon name={type} />} />
                </ListItemAvatar>
                <ListItemText
                  primary={title}
                  secondary={
                    <>
                      <TimeAgo date={date} accurate /> - {getResultTypeName(type)}
                    </>
                  }
                />
                <ListItemAvatar>
                  <Chip icon={<Star style={{ fontSize: 12 }} />} label={score.toFixed(2)} />
                </ListItemAvatar>
              </ListItem>
            ))}
          </List>
        )}
        {searchText && called && !loading && (!data || (data && !data.searchAll.results.total)) && (
          <IconMessage name="empty-search" text="We couldn't find any results." />
        )}
      </Content>
    </>
  )
}

export default Search
